import type { BadgeCriterion } from '@contracts';

/**
 * Plain-language criterion sentence for a badge (owner's standing
 * transparency requirement — badges-and-celebrations.md SS1.1 "wordmark
 * slot", settings-rewards.md SS3: "the user must never wonder what a badge
 * means or how to earn it"). Pure string formatting only; the badge's
 * progress/earned state is separate (BadgeStateView), rendered alongside
 * this, never inside it.
 */
export function describeCriterion(criterion: BadgeCriterion): string {
  switch (criterion.kind) {
    case 'habit_completions':
      return `Complete this habit ${criterion.count} time${criterion.count === 1 ? '' : 's'}`;
    case 'checkin_streak_weeks':
      return `Check in ${criterion.weeks}-week streak`;
    case 'accepted_recalibrations':
      return `Accept ${criterion.count} adjustment${criterion.count === 1 ? '' : 's'}`;
    case 'clean_weeks':
      return `${criterion.weeks} clean week${criterion.weeks === 1 ? '' : 's'} on this habit`;
    case 'weekly_reviews':
      return `Complete ${criterion.count} weekly review${criterion.count === 1 ? '' : 's'}`;
    case 'action_completions':
      return `Complete ${criterion.count} action${criterion.count === 1 ? '' : 's'}`;
    default: {
      const exhaustive: never = criterion;
      return exhaustive;
    }
  }
}
